import React from 'react';

import { useDidMount } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useLogger } from '@hooks';

interface UnexpectedErrorProps {
	error: string; // injected by ErrorBoundary component
}

export const UnexpectedError: React.FC<UnexpectedErrorProps> = ({ error }) => {
	const logger = useLogger();

	useDidMount(() => {
		logger('UnexpectedError', error);
	});

	return null;
};
